export const patientHelper = {
  getFullName(patientItem: any) {
    return `${patientItem.name1} ${patientItem.name2}`
  },
}
